export default "__VITE_ASSET__BA0XmdNU__"